export default __webpack_public_path__ + "static/media/google_meet.ac6cd62e.svg";